import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12e2db1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-Text/text_high text-[14px] pb-2 font-gordita-medium px-4 pt-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "w-full wrap flex justify-between"
}
const _hoisted_4 = { class: "text-Text/text_high" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_6 = { class: "mt-[8px] w-full wrap flex justify-between" }
const _hoisted_7 = { class: "text-Text/text_high" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1))
const _hoisted_9 = { class: "text-Text/text_medium flex justify-between mt-2 text-[12px] items-center" }
const _hoisted_10 = { class: "text-Text/text_medium text-[12px] mt-[14px]" }
const _hoisted_11 = { class: "submission--footer-container" }
const _hoisted_12 = { class: "submission--footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Submit ")

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton, IncrediField, IncrediForm, IncrediToggle, useIncrediForm } from 'incredi-ui';
import { SelectedAgent } from '@/components/agents-table/AgentActionMenu.types';
import elementsIds from '@/const/elementIds.json';
import { computed, inject, ref } from 'vue';
import { License_RegisterAgentAction, License_RegistrationType, useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-server-subscription',
  props: {
    agents: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({ (e: 'change', payload: object): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  agents: SelectedAgent[];
}


const autoAssign = ref(true);
const isBulk = props.agents.length > 1;

const coordinatorsService = inject(IKCoordinatorsService);
const GQL_useLicenseInfoQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
const licenseDetails = computed(() => GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license?.linux?.licenseDetails || []);

const serverCoresDetails = computed(() => licenseDetails.value?.filter((item: any) => item?.packageType === 1)[0]);
const totalAvailableCores = computed(() => (serverCoresDetails.value?.packageNumCores || 0) - (serverCoresDetails.value?.coresInUse || 0));

const licensedCores = isBulk ? 0 : props.agents[0]?.license?.registeredCores;
const agentCoresMax = props.agents[0]?.performance?.cpuPhysical || 0;
const { form, fields } = useIncrediForm({
  initialValues: {
    server: isBulk ? 0 : props.agents[0]?.license?.registeredCores,
  },
  validationSchema: {
    server: [
      (v: number) => {
        if (!isBulk && agentCoresMax && v > agentCoresMax) {
          return `Value must be less or equal to ${agentCoresMax}`;
        }
        return true;
      },
    ],
  },
});

// eslint-disable-next-line no-unused-vars


const getRequestedCores = (agent: SelectedAgent) => {
  const coresNumber = fields.server.value.value || 0;
  if (autoAssign.value) {
    return agent.performance?.cpuPhysical;
  }
  return (agent.performance?.cpuPhysical || 0) <= coresNumber ? agent.performance?.cpuPhysical : coresNumber;
};

const handleServerUpdate = async (server: number | null) => {
  fields.server.value.value = server;
};

const disableSubmit = computed(() => {
  if (autoAssign.value) {
    return false;
  }
  const value = Number(fields.server.value.value);
  return !value;
});
// in case Core Assignment toggle is on,use maximum cores available which is cpuPhysical(agentCoresMax)
const onSubmit = form.handleSubmit(async () =>
  emit(
    'change',
    props.agents.map(agent => {
      const agentId = agent?.id as string;
      // SUVM - floating, Server - Fixed
      const helperLicense = License_RegistrationType.Fixed;
      const requestedCores = Number(getRequestedCores(agent));

      return {
        action: License_RegisterAgentAction.LicenseConfig,
        agentId,
        helperLicense,
        requestedCores,
        coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
        ciInitiatorLicense: License_RegistrationType.None,
        initiatorLicense: License_RegistrationType.None,
      };
    }),
  ),
);

return (_ctx: any,_cache: any) => {
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return _withDirectives((_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([isBulk ? 'h-[288px]' : 'h-[296px]', "w-[288px] relative overflow-hidden"])
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('agentsTable.linuxActionsMenu.serverTitle')), 1),
        _hoisted_2,
        _createVNode(_unref(IncrediForm), {
          class: "w-full h-full flex flex-col px-4",
          onSubmit: _withModifiers(_unref(onSubmit), ["prevent"]),
          onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => ($event.preventDefault()), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["text-Text/text_medium text-[12px] mb-4", isBulk ? 'pt-2' : 'pt-4'])
            }, [
              (!isBulk)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('agentsTable.linuxActionsMenu.currentAgentCores')), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(_unref(licensedCores)), 1),
                      _hoisted_5,
                      _createElementVNode("span", null, _toDisplayString(_unref(agentCoresMax)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('agentsTable.linuxActionsMenu.availableAgentCores')), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(totalAvailableCores)), 1)
              ])
            ], 2),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('agentsTable.linuxActionsMenu.assignmentExplanation')), 1),
              _createVNode(_unref(IncrediToggle), {
                modelValue: autoAssign.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((autoAssign).value = $event)),
                disabled: false,
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('agentsTable.linuxActionsMenu.assignmentFieldLabel')), 1),
            _createVNode(_unref(IncrediField), {
              "data-testid": _unref(elementsIds).agents.contextMenu.subscribeServer.input,
              disabled: autoAssign.value,
              class: "transition-all !duration-[200ms] mt-2",
              error: !!_unref(form).errors.value.server,
              "error-message": _unref(form).errors.value.server,
              name: "server",
              "field-type": "number",
              label: "Cores To Assign",
              size: "tiny",
              "model-value": (_unref(fields).server.value.value as any),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => handleServerUpdate(value)),
              onChange: _cache[3] || (_cache[3] = () => _unref(fields).server.validate())
            }, null, 8, ["data-testid", "disabled", "error", "error-message", "model-value"])
          ]),
          _: 1
        }, 8, ["onSubmit"]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(IncrediButton), {
              "data-testid": "submit-subscribe",
              design: "primary-green",
              size: "small",
              disabled: _unref(disableSubmit),
              onKeydown: _withKeys(_withModifiers(_unref(onSubmit), ["prevent"]), ["enter"]),
              onClick: _withModifiers(_unref(onSubmit), ["stop","prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["disabled", "onKeydown", "onClick"])
          ])
        ])
      ], 2)
    ]),
    _: 1
  })), [
    [_directive_incredi_focus_trap, 'agent-subscription']
  ])
}
}

})